module.exports = __webpack_public_path__ + "img/asmntprogactive.143e7b2e.svg";